import React, { ReactNode } from "react";
import "./LoginWrapper.scss";

interface LoginWrapperProps {
  children: ReactNode;
  className?: string;
}

const LoginWrapper: React.FC<LoginWrapperProps> = ({
  children,
  className = "",
}) => {
  return (
    <main className={`login-wrapper ${className}`}>
      <div className="login-wrapper__background-wrapper">
        <img
          src={require("../../assets/images/loginPageBg.webp")}
          className="login-wrapper__background"
          alt="Background"
        />
      </div>
      <div className="login-wrapper__content">{children}</div>
    </main>
  );
};

export default LoginWrapper;
